import { MijnRoute } from '../../mijn-navigatie.model';

export const OVERVIEW_EDIT: MijnRoute = {
    path: 'overzicht-aanpassen',
    navigationEvent: 'toOverviewEdit',
    regex: /^\/overzicht-aanpassen$/,
    webcomponent: 'mijn-overzicht',
    internalPath: '/overzicht-aanpassen'
};
